import InviteLeadModalContainer from "./InviteLeadModalContainer";

export default InviteLeadModalContainer;
